import {serviceApiHostName} from "../../endpoint";
import {defaultHeaders} from "../../headers";

export const createService = async (model) => {
  try {
    const result = await fetch(`${serviceApiHostName}/service`, {
      method: "POST",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      body: JSON.stringify(model),
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
